import { createContext, useContext } from "react";

/**
 * Interface for the side navigation context
 */
interface ISideNavContext {
  /**
   * Current location pathname for routing
   */
  location: string;
  /**
   * Function to update the current location
   */
  setLocation: (location: string) => void;
}

const defaultContext = {
  location: "",
  setLocation: (_location: string) => {},
};

export const SideNavContext: React.Context<ISideNavContext> =
  createContext(defaultContext);

/**
 * Custom hook for accessing the SideNav context.
 * @returns The SideNav context with location and setLocation
 */

export const useSideNavContext = () => useContext(SideNavContext);
